// API Configuration - CORRECT VERSION
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.neplishop.com';

export default API_BASE_URL;